import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import Navbar from '../layout/Navbar';
import Preloader from '../layout/preloader';
import ListarDocumentos from '../section-pages/documentos-listar';
import Footer from '../section-pages/footer';
import ScrollToTopBtn from '../layout/ScrollToTop';
import ApiDocumento from '../services/documentoService';
import { useParams } from 'react-router-dom';

export default function Documentos() {
  const { slug } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [documentos, setDocumentos] = useState([]);

  const fetchDocumentos = async (slug) => {
    try {
      setIsLoading(true);
      const response = await ApiDocumento.listar(slug);

      if (response?.data) {
        setDocumentos(response.data.documentos || []);
      } else {
        console.warn('No data returned from API.');
      }
    } catch (error) {
      console.error('Erro ao buscar Documentos:', error);
    } finally {
      setIsLoading(false);
    }
  };
  
  useEffect(() => {
    fetchDocumentos(slug);
  }, []);

  return (
    <>
      <Helmet>
        <link rel="icon" href="./img/icon.png" />
        <title>Fetron - Federação de Taekwondô de Rondônia</title>
      </Helmet>

      <div id="mainpreloader" style={{ display: isLoading ? 'block' : 'none' }}>
        <Preloader />
      </div>

      <div className="home dark-scheme">
        <header id="header-wrap">
          <Navbar />
        </header>
        <section className="no-bg">
          <div>
            <img src="../../img/background/bg-header.png" width="100%"/>
          </div>
          <div className="container z-9">
            <div className="row align-items-center">
              <div className="col-lg-12">
                <center>
                  {isLoading ? (
                    <p style={{ textAlign: 'center', marginTop: '20px' }}>Carregando...</p>
                  ) : (
                    <section>
                      <ListarDocumentos
                        documentos={documentos}
                      />
                    </section>
                  )}
                </center>
              </div>        
            </div>
          </div>
        </section>

        <Footer />
      </div>
      <ScrollToTopBtn />
    </>
  );
}
